import { defineStore } from 'pinia';
import http from '../api/httpRequest.js'
import { RTC_STATE } from "../api/enums.js"

export default defineStore('userStore', {
	state: () => {
		return {
			userInfo: {},
			// 财务业务协作角色: 0未分配/业务员 1业务员 2财务 3管理员 (来自 GET /biz/me)
			bizRole: 0,
			// 多角色集合(可同时含1/2/3),兼容旧单角色bizRole
			bizRoles: [],
			rtcInfo: {
				friend: {},  // 好友信息
				mode: "video", // 模式 video:视频 voice:语音
				state: RTC_STATE.FREE // FREE:空闲  WAIT_CALL:呼叫方等待 WAIT_ACCEPT: 被呼叫方等待接听  CHATING:聊天中 
			}
		}
	},
	getters: {
		// 财务能力: 含财务(2)或管理员(3)角色
		isBizFinance: (state) => state.bizRoles.includes(2) || state.bizRoles.includes(3)
			|| state.bizRole === 2 || state.bizRole === 3,
		// 业务员能力: 含业务员(1)或管理员(3)角色
		isBizSales: (state) => state.bizRoles.includes(1) || state.bizRoles.includes(3)
			|| state.bizRole === 1 || state.bizRole === 3,
		// 管理员能力: 仅含管理员(3)角色
		isBizAdmin: (state) => state.bizRoles.includes(3) || state.bizRole === 3,
	},
	actions: {
		setUserInfo(userInfo) {
			this.userInfo = userInfo
		},
		setBizRole(role) {
			this.bizRole = role || 0;
		},
		setBizRoles(roles) {
			this.bizRoles = Array.isArray(roles) ? roles.map(Number).filter((v) => v > 0) : [];
		},
		setRtcInfo(rtcInfo) {
			this.rtcInfo = rtcInfo;
		},
		setRtcState(rtcState) {
			this.rtcInfo.state = rtcState;
		},
		clear() {
			this.userInfo = {};
			this.bizRole = 0;
			this.bizRoles = [];
			this.rtcInfo = {
				friend: {},
				mode: "video",
				state: RTC_STATE.FREE
			};
		},
		loadUser() {
			return new Promise((resolve, reject) => {
				http({
					url: '/user/self',
					method: 'GET'
				}).then((userInfo) => {
					this.setUserInfo(userInfo);
					resolve();
				}).catch((res) => {
					reject(res);
				});
			})
		},
		// 加载财务业务协作角色，尽力而为：失败不阻断应用启动
		loadBizRole() {
			return new Promise((resolve) => {
				http({
					url: '/biz/me',
					method: 'GET'
				}).then((info) => {
					this.setBizRole(info && info.role);
					this.setBizRoles(info && info.roles);
					resolve(info);
				}).catch(() => {
					this.setBizRole(0);
					this.setBizRoles([]);
					resolve(null);
				});
			})
		}
	}
});